export default {
  login: 'Connexion',
  logout: 'Déconnexion',
  loginWith: 'Se connecter avec Nextcloud',
  loginError: 'Échec de la connexion. Veuillez réessayer.',
  sessionExpired: 'Votre session a expiré. Veuillez vous reconnecter.'
};
